import React, { FC, Fragment } from "react";

import { Accordion } from "@at/design-system-patterns";

import * as Styled from "./technical-specification-list.styled";
import { ITechnicalSpecificationListProps } from "./technical-specification-list.types";

export const TechnicalSpecificationList: FC<
  ITechnicalSpecificationListProps
> = ({ techSpecData, standardEquipmentData }) => {
  const hasTechSpecData = techSpecData && techSpecData.length > 0;
  const hasStandardEquipmentData =
    standardEquipmentData && standardEquipmentData.length > 0;

  return (
    <Fragment>
      {hasTechSpecData && (
        <Styled.TechSpecWrapper>
          <Styled.Heading as="h3">Technical specification</Styled.Heading>
          <Accordion items={techSpecData} />
        </Styled.TechSpecWrapper>
      )}
      {hasStandardEquipmentData && (
        <Styled.StandardEquipmentWrapper>
          <Styled.Heading as="h3">Standard equipment</Styled.Heading>
          <Accordion items={standardEquipmentData} />
        </Styled.StandardEquipmentWrapper>
      )}
    </Fragment>
  );
};
